import regulationTypes from '../regulationTypes';

export default [
    {
        countryCode: 'US',
        regionCode: 'NJ',
        regulations: [
            { name: regulationTypes.DOUBLE_REBET_PROMPT },
        ]
    },
    {
        countryCode: 'CA',
        regionCode: 'LQ',
        regulations: [
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 3 } },
            { name: regulationTypes.VERSION },
            { name: regulationTypes.TURBO }
        ]
    },
    {
        countryCode: 'CA',
        regionCode: 'ON',
        regulations: [
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 2.5 } },
            { name: regulationTypes.TURBO },
            { name: regulationTypes.TURBO_SPIN },
            { name: regulationTypes.SKIP_ANIMATION },
            { name: regulationTypes.RESTRICT_ROUND_CELEBRATIONS },
        ]
    },
    {
        countryCode: 'CA',
        regionCode: 'BC',
        regulations: [
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 3 } },
            { name: regulationTypes.TURBO }
        ]
    },
    {
        countryCode: 'AR',
        regionCode: 'C',
        regulations: [
            { name: regulationTypes.VOLATILITY_INDEX },
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 3 } },
            { name: regulationTypes.TURBO }
        ]
    },
    {
        countryCode: 'AR',
        regionCode: 'X',
        regulations: [
            { name: regulationTypes.VOLATILITY_INDEX }
        ]
    },
    {
        countryCode: 'AR',
        regionCode: 'M',
        regulations: [
            { name: regulationTypes.MIN_ROUND_DURATION, options: { duration: 3 } },
            { name: regulationTypes.TURBO }
        ]
    },
    {
        countryCode: 'US',
        regionCode: 'CT',
        regulations: [
            { name: regulationTypes.CUSTOM_LANGUAGE, options: { lang: 'en-CT' } }
        ]
    },
];
